<template>
  <Book />
</template>

<script>
import  Book  from "../callCenter/book";
export default {
  name: "doctor-arrival",
  components: {
    Book,
  },
  data() {
    return {
      
    };
  },
  methods: {
    
  },
  mounted() {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
